import type { schema } from "@msuite/zero";
import type { Row } from "@rocicorp/zero";
import { createContext, useContext } from "react";

/** Interface */
interface ICrewContext {
	crew: Row<typeof schema.tables.crews>;
	crewId: string;
	planId: string;
	/**
	 * Whether this crew's staffing is read-only for the caller. Separate from the board-wide
	 * `isInteractionBlocked` because it is decided per column rather than per day: only the
	 * organisation that owns a crew may put its people into it, so a host looking at a partner's
	 * column sees the staffing and cannot change it, while the partner can — on the very same board.
	 * That includes a guest board, where staffing an own column is the one open control; a published
	 * plan freezes staffing for everyone.
	 */
	isStaffingBlocked: boolean;
}

/** Context */
export const CrewContext = createContext<ICrewContext>({} as ICrewContext);

/** Hooks */
export function useCrewContext() {
	return useContext(CrewContext);
}
